export default __webpack_public_path__ + "static/media/square-clock.4d43980c.svg";